import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainPage from './mainpage';
import MainPage2 from './mainpage2';
import PEntitiesPage from './pEntities';
import SearchAssistantPage from './SearchAssistant';
import PShareEmailPage from './pShareEmail';
import DocSearchPage from './docSearch';
import CaseStudy from './caseStudy';
import Automation from './automation';
import HRTemplate from './hr-template';
import HRHub from './HRHub';
import Finance from './Finance';
import CaseManagement from './case-management';
import Metadata from './metadata';
import GetStarted from './get-started';
import Contact from './Contact';
import Schedule from './schedule';
import About from './about';
import Bioland from './bioland';
import Privacy from './privacy';
import TermsOfUse from './terms-of-use';
import DPA from './DPA';
import Knowledge from './Knowledge';
import Technical from './technical';
import PlansAndPricing from './plans';
import Ticketing from './ticketing';
import Features from './features';
import NotFound from './NotFound';
import SeoManager from './SeoManager';
import ReadTime from './ReadTime';
import './App.css';
import { FluentProvider, webLightTheme } from '@fluentui/react-components';

// NOTE ON CODE SPLITTING
// Routes are intentionally imported eagerly rather than via React.lazy.
//
// scripts/prerender.js writes fully-rendered HTML for every route, and index.tsx
// hydrates it. React.lazy breaks that: during hydration the chunk has not loaded,
// so React renders the Suspense fallback, which never matches the prerendered
// markup - every page threw hydration error #418 and React discarded the
// prerendered DOM it was meant to reuse.
//
// Resolving this properly needs a build manifest that maps each route to its chunk
// and preloads it before hydration, which is framework territory (Next.js does this
// out of the box). Until then, prerendered HTML is worth more than the split: first
// paint no longer waits on JavaScript at all.
function App() {
  return (
    <FluentProvider theme={webLightTheme}>
      <Router>
        <div className="App">
          <SeoManager />
          <ReadTime />
          <Routes>
            <Route path="/" element={<MainPage />} />
            <Route path="/mainpage2" element={<MainPage2 />} />
            <Route path="/about" element={<About />} />
            <Route path="/bioland" element={<Bioland />} />
            <Route path="/get-started" element={<GetStarted />} />
            <Route path="/contactus" element={<Contact />} />
            <Route path="/schedule" element={<Schedule />} />
            <Route path="/the-challenge" element={<CaseStudy />} />
            <Route path="/casestudy" element={<CaseStudy />} />
            <Route path="/solutions/pentities" element={<PEntitiesPage />} />
            <Route path="/pentities" element={<PEntitiesPage />} />
            <Route path="/solutions/searchassistant" element={<SearchAssistantPage />} />
            <Route path="/solutions/pshareemail" element={<PShareEmailPage />} />
            <Route path="/solutions/docsearch" element={<DocSearchPage />} />
            <Route path="/solutions/automation" element={<Automation />} />
            <Route path="/solutions/hr-template" element={<HRTemplate />} />
            <Route path="/solutions/hr-hub" element={<HRHub />} />
            <Route path="/solutions/finance" element={<Finance />} />
            <Route path="/solutions/case-management" element={<CaseManagement />} />
            <Route path="/solutions/ticketing" element={<Ticketing />} />
            <Route path="/solutions/features" element={<Features />} />
            <Route path="/solutions/metadata" element={<Metadata />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms-of-use" element={<TermsOfUse />} />
            <Route path="/dpa" element={<DPA />} />
            <Route path="/knowledge" element={<Knowledge />} />
            <Route path="/technical-support" element={<Technical />} />
            <Route path="/plans-pricing" element={<PlansAndPricing />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </div>
      </Router>
    </FluentProvider>
  );
}

export default App;
